enum KeyCode {
  SPACE = 32,
}

export default KeyCode;
